// extracted by mini-css-extract-plugin
export default {"texBox":"TeXBox_texBox__t-y5A","focusedParagraph":"TeXBox_focusedParagraph__DCRO-"};